import { useCallback, useContext } from "react";
import {
    IRegisterFromCPFNumberRequest,
    IRegisterFromCPFUserRequest,
} from "@finbackoffice/clientbff-client";
import { ClientBFFContext } from "../providers";

export const useOneStepCpfSignup = () => {
    const client = useContext(ClientBFFContext);

    const registerCPFUser = useCallback(
        async (
            data: IRegisterFromCPFNumberRequest | IRegisterFromCPFUserRequest,
            cpfVerified: boolean,
        ) => {
            if (cpfVerified) {
                return await client.registerFromCPFNumber(data);
            } else {
                return await client.registerFromCPFUser(data);
            }
        },
        [client],
    );

    return { registerCPFUser };
};
